import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { auth, createUserProfileDocument } from "../firebase";

import { ColorModeContext } from "../context/ColorModeProvider";

import { toast } from "react-toastify"; // then this

import {
  CssBaseline,
  Container,
  Grid,
  Card,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  Button,
  TextField,
  FormControl,
  Stack,
} from "@mui/material";

const SignUp = () => {
  const { theme } = useContext(ColorModeContext);

  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("pending");
  const history = useHistory("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (displayName && email && password && role) {
      try {
        const { user } = await auth.createUserWithEmailAndPassword(
          email,
          password
        );

        createUserProfileDocument(user, { displayName, role });

        // Alert.success("Successfully Signed Up");
        toast.success("Successfully Signed Up", {
          theme: "colored",
        });
        history.push("/");
      } catch (error) {
        // Alert.error(error.message, 3000);
        toast.error(`${error.message}`, {
          theme: "colored",
        });
      }
    } else {
      // Alert.error("Plzz Fill All Fields", 3000);
      toast.error("Please, fill all fields", {
        theme: "colored",
      });
    }
  };

  return (
    <Container size="sm">
      <CssBaseline />
      <Grid
        container
        spacing={0}
        // style={{ minWidth: "600px" }}
        style={{
          minHeight: "100vh",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            color={theme.palette.mode === "dark" ? "#fff" : "#254c73"}
            component="h2"
            gutterBottom
          >
            Register
          </Typography>
          <Card sx={{ pl: 4, pr: 4, pt: 5, pb: 5 }}>
            <form onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  value={displayName}
                  label="Username"
                  // onChange={(e) => setDisplayName(e)}
                  onChange={(e) => setDisplayName(e.target.value)}
                  name="name"
                />
                <TextField
                  value={email}
                  label="Email"
                  // onChange={(e) => setEmail(e)}
                  onChange={(e) => setEmail(e.target.value)}
                  name="name"
                />
                <TextField
                  name="password"
                  value={password}
                  label="Password"
                  // onChange={(e) => setPassword(e)}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                />
                {/* <TextField
                  name="role"
                  value={role}
                  label="Role"
                  onChange={(e) => setRole(e.target.value)}
                  type="role"
                /> */}
                <FormControl fullWidth>
                  <InputLabel>Role</InputLabel>
                  <Select
                    labelId="user-role-select-label"
                    label="Role"
                    id="user-role-select"
                    value={role}
                    disabled
                    // onChange={handleChange}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="editor">Editor</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                </FormControl>
              </Stack>

              <Stack
                direction="row"
                mt={4}
                spacing={2}
                justifyContent="space-between"
              >
                <Button
                  // sx={{ backgroundColor: "#EA502A" }}
                  variant="contained"
                  type="submit"
                  // style={{ color: "#fff" }}
                >
                  Register
                </Button>
                <Typography sx={{ pt: 2, pb: 2 }}>
                  <Link
                    style={{
                      color:
                        theme.palette.mode === "dark" ? "#00bfc6" : "#00bfc6",
                      textDecoration: "none",
                    }}
                    to="/login"
                  >
                    Login
                  </Link>
                </Typography>
              </Stack>
            </form>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignUp;
